/* eslint-disable react/require-default-props */

import React from 'react';

const LegendItem = (props) => (
  <div className="legend-text">
    <small> {props.itemText}</small>
    <strong>
      {props.prefix}
      {props.itemValue}
      {props.suffix}
    </strong>
  </div>
);

export default LegendItem;
